import { render } from "./TestHome.vue?vue&type=template&id=e9f9be74&scoped=true"
import script from "./TestHome.vue?vue&type=script&lang=js"
export * from "./TestHome.vue?vue&type=script&lang=js"

import "./TestHome.vue?vue&type=style&index=0&id=e9f9be74&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9f9be74"]])

export default __exports__